import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'LINEARREG',
  version: 1,
  label: 'Linear Regression',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 60,
  inputs: [period('timeperiod', 14)],
  outputs: [line('linearreg', 'LinReg', COLOR.blue)],
  talib: { functions: ['LINEARREG'], expr: 'LINEARREG(close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod - 1,
}
export default def
